module.exports = __webpack_public_path__ + "static/img/asklogo.ab9f5472.png";